import * as React from "react";

import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function AIIcon(props: SvgIconProps): React.JSX.Element {
    return (
        <SvgIcon
            viewBox="0 0 61 59"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M6.11278 18.3978C7.89701 18.3978 9.34341 16.9514 9.34341 15.1672C9.34341 13.3829 7.89701 11.9365 6.11278 11.9365C4.32855 11.9365 2.88214 13.3829 2.88214 15.1672C2.88214 16.9514 4.32855 18.3978 6.11278 18.3978Z"
                fill="#9429FF"
            />
            <path
                d="M6.11278 46.6234C7.89701 46.6234 9.34341 45.177 9.34341 43.3927C9.34341 41.6085 7.89701 40.1621 6.11278 40.1621C4.32855 40.1621 2.88214 41.6085 2.88214 43.3927C2.88214 45.177 4.32855 46.6234 6.11278 46.6234Z"
                fill="#9429FF"
            />
            <path
                d="M54.613 46.8954C56.3973 46.8954 57.8437 45.4489 57.8437 43.6647C57.8437 41.8805 56.3973 40.4341 54.613 40.4341C52.8288 40.4341 51.3824 41.8805 51.3824 43.6647C51.3824 45.4489 52.8288 46.8954 54.613 46.8954Z"
                fill="#9429FF"
            />
            <path
                d="M54.613 18.3978C56.3973 18.3978 57.8437 16.9514 57.8437 15.1672C57.8437 13.3829 56.3973 11.9365 54.613 11.9365C52.8288 11.9365 51.3824 13.3829 51.3824 15.1672C51.3824 16.9514 52.8288 18.3978 54.613 18.3978Z"
                fill="#9429FF"
            />
            <path
                d="M30.1283 57.7229C34.3804 57.7229 37.8274 45.098 37.8274 29.5245C37.8274 13.951 34.3804 1.32617 30.1283 1.32617C25.8762 1.32617 22.4292 13.951 22.4292 29.5245C22.4292 45.098 25.8762 57.7229 30.1283 57.7229Z"
                stroke="#9429FF"
                strokeWidth="1"
                fill="none"
                style={{ vectorEffect: "non-scaling-stroke" }}
            />
            <path
                d="M35.8331 39.4074C49.3202 31.6206 57.6988 20.8831 54.5473 15.4246C51.3958 9.96597 37.9075 11.8533 24.4205 19.6401C10.9334 27.4268 2.55481 38.1643 5.70632 43.6229C8.85784 49.0815 22.3461 47.1941 35.8331 39.4074Z"
                stroke="#9429FF"
                strokeWidth="1"
                fill="none"
                style={{ vectorEffect: "non-scaling-stroke" }}
            />
            <path
                d="M54.548 43.6253C57.6995 38.1667 49.3209 27.4292 35.8339 19.6424C22.3468 11.8557 8.85857 9.96832 5.70706 15.4269C2.55554 20.8855 10.9342 31.623 24.4212 39.4097C37.9083 47.1965 51.3965 49.0838 54.548 43.6253Z"
                stroke="#9429FF"
                strokeWidth="1"
                fill="none"
                style={{ vectorEffect: "non-scaling-stroke" }}
            />
        </SvgIcon>
    );
}
